import React, {useEffect, useState} from 'react';
import { useDispatch, useSelector } from "react-redux";

import { loading, patient, processing } from "../../store/reducers/patient";
import Pagination from '@mui/material/Pagination';

import SvgIcon from "@mui/material/SvgIcon";
import IconButton from "@mui/material/IconButton";

import makeStyles from '@mui/styles/makeStyles';

import { useTranslation } from "react-i18next";
import moment from "moment";
import {useHistory, useLocation, useParams} from 'react-router-dom';
import {
    documents,
    getSelectedDocuments,
    loadDocumentsForPatientById,
    setDocuments,
} from '../../store/reducers/documents';

import {holding, patient as patientPreferences, setHoldingPreference} from '../../store/reducers/preferences';
import config from "../../app/config";

import {BackIcon} from '../icons/icons';
import PatientInfo from "./patientInfo";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import UserMenu from "./userMenu";
import {globalVariable, setGlobalVariable, setSnackbar} from '../../store/reducers/globals';
import LinkIcon from '@mui/icons-material/Link';
import PersonIcon from '@mui/icons-material/Person';
import Links from './links'
import MedicationIcon from '@mui/icons-material/Medication';
import {
    ButtonGroup,
} from "@mui/material";
import HoldingPenMenu from "./holdingPenMenu";
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import AgyleDialog from '../modal/agyleDialog';
import AdminPatientEyonix from '../../pages/admitPatientEyonix/adminPatientEyonix';
import useOpenState from '../../hooks/useOpenState';
import {hasPermission, isAdmin, Permissions, user} from '../../store/reducers/user';
import CachedIcon from '@mui/icons-material/Cached';
import Tooltip from '@mui/material/Tooltip';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import AgyleButton from '../ui/buttons/agyleButton';
import {globalImageCache} from '../../pages/viewer/imageCache';
import ScienceIcon from "@mui/icons-material/Science";


const useStyles = makeStyles((theme) => ({
    headerPanel: {
        width: "100vw",
        backgroundColor: theme.palette.background.header,
        // height: "44px",
        // lineHeight: "44px",
        // padding: "0 20px",
        height: "48px",
        lineHeight: "48px",

        /*
        -webkit-box-shadow: 0px 10px 13px -7px #000000, 5px 5px 15px 5px rgba(0,0,0,0);
        box-shadow: 0px 10px 13px -7px #000000, 5px 5px 15px 5px rgba(0,0,0,0);
        */
        // TODO: this need to be somehow stored in settings for global palette ?
        boxShadow: "0px 7px 10px -7px #1a1a1a, 5px 5px 15px 5px rgba(0,0,0,0)",
    },
    headerObject: {
        position: "absolute",
        width: "100vw",
    },
    headerName: {
        position: "absolute",
        width: "100vw",
        paddingLeft: 64,
        zIndex: 1,
    },
    headerText: {
        position: "absolute",
        width: "100vw",
        textAlign: "center",
        // fontWeight: 700
        fontSize: 12
    },
    buttonsContainers: {
        position: "absolute",
        right: 30,
        display: "inline-flex",
        alignItems: "center"
    },
    headerButtons: {
        // top: 3,
        // zIndex: 1,
        position: "absolute",
        right: 10,
        textAlign: "right",
        zIndex: 1,
    },
    documentCountBox: {
        height: "30px",
        backgroundColor: "#616161",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "10px",
        borderRadius: 3
    },
    headerLoading: {
        position: "absolute",
        width: "100vw",
        textAlign: "center",
        marginTop: 7,
        // fontWeight: 700
        zIndex: 2,
    },
    fullName: {
        display: "inline-block",
        marginLeft: 10,
        fontWeight: 300,
    },
    familyName: {
        fontWeight: "bold",
        textTransform: "uppercase",
        marginRight: 5,
    },
    akaName: {
        paddingRight: "10px",
    },
    alert: {
        padding: "10px",
        borderBottom: "1px solid white"
    },
    alertType: {
        textAlign: "center"
    },
    alertGroup: {
        fontWeight: "bold",
        paddingTop: "10px"
    },
    alertBoldText: {
        fontWeight: "bold"
    },
    alertText: {
        paddingTop: "10px"
    },
    paper: {
        position: 'absolute',
        width: 400,
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
    modalBody: {
        left: "10%",
        width: "80%",
        top: "70px"
    },
    gpDetails: {
        borderLeft: "1px solid white",
        paddingLeft: "10px"
    },
    noItem: {
        color: "grey"
    },
    menuIcon: {
        zIndex: 2
    },
    linksIcon: {
        position: "absolute",
        right: 0
    }
}));

function Header(props) {
    const classes = useStyles();
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch();
    const match = useLocation();
    const history = useHistory();

    const isHoldingPen = match.pathname === "/holding" ||
        process.env.BUILD_MODULE === "lwh" ||
        process.env.BUILD_MODULE === "dch" ||
        process.env.BUILD_MODULE === "stg" ||
        process.env.BUILD_MODULE === "mse";
    const isResearchHolding = match.pathname === "/researchholding";

    const isHoldingPenViewer = match.pathname.startsWith("/view/" + config.modules.holdingPen.name);
    const isResearchViewer = match.pathname.startsWith("/view/" + config.modules.research.name);

    const isResearch = useSelector(globalVariable("isResearch")) || match.pathname.startsWith("/research/list");
    const researchReload = !!useSelector(globalVariable("extraDocFilter"));

    const patientObject = useSelector(patient);
    const loadingPatientObject = useSelector(loading);
    const processingPatientObject = useSelector(processing);
    const userObject = useSelector(user);

    const documentsObject = useSelector(documents);

    const holdingPreferenceObject = useSelector(holding);
    const [isNewPatientModalOpen, openNewPatientModal, closeNewPatientModal] = useOpenState(false, true);
    const [canAccessHoldingPen, setCanAccessHoldingPen] = useState(false);
    const [canAccessResearchHoldingPen, setCanAccessResearchHoldingPen] = useState(false);
    const [canCreatePatient, setCanCreatePatient] = useState(false);

    useEffect(() => {
        if (userObject && userObject.permissions) {
            if (dispatch(hasPermission(Permissions.CAN_VIEW_PATIENT_RECORD)) && (
                !config.modules.holdingPen.accessPermission ||
                dispatch(hasPermission(config.modules.holdingPen.accessPermission)) ||
                dispatch(isAdmin()))) {
                    setCanAccessHoldingPen(true);
            } else {
                setCanAccessHoldingPen(false);
            }
            if (dispatch(hasPermission(Permissions.CAN_VIEW_PATIENT_RECORD)) && (
                !config.modules.research.accessPermission ||
                dispatch(hasPermission(config.modules.research.accessPermission)))) {
                    setCanAccessResearchHoldingPen(true);
            } else {
                setCanAccessResearchHoldingPen(false);
            }
            if (dispatch(hasPermission(Permissions.CAN_VIEW_PATIENT_RECORD)) && (
                dispatch(hasPermission(Permissions.CAN_CREATE_PATIENT)) || dispatch(isAdmin()))) {
                setCanCreatePatient(true);
            } else {
                setCanCreatePatient(false);
            }
        }
        return () => {
            setDocuments({
                patientId: undefined,
                documents: undefined,
            });
        };
    }, [userObject]);

    useEffect(() => {
        // clear image cache after patient change
        globalImageCache.clean();
    }, [patientObject]);

    // TODO: what we need to show here depends on context and maybe on link - but definitely on the fact is patient selected !

    // FIXME: to some sort of util class ?
    const patientDOB = () => {
        if (patientObject) {
            const dob = moment(patientObject.dob);
            return dob.format(config.defaultDateFormat);
        }
        return "";
    };

    const patientYears = () => {
        if (patientObject) {
            return moment().diff(moment(patientObject.dob), "years");
        }
        return "";
    };

    const backButtonVisible = () => {
        return !props.openFromLink || history.location.pathname.includes("view")
    }

    const getHeaderPatientElement = () => {
        if (loadingPatientObject) {
            return (
                <div className={classes.headerLoading}>
                    {/*<CircularProgress size={32}/>*/}
                </div>
            );
        } else {
            // FIXME: that may be useful in agyle as well however for now make no sense !
            if (patientObject && !isResearch && !isResearchViewer && process.env.BUILD_MODULE === "main") {
                return (
                    <div className={classes.headerObject}>
                        <div className={classes.headerName}>
                            {backButtonVisible() && <IconButton size="small" onClick={handleBackButton}>
                                <BackIcon />
                            </IconButton> }
                            <div className={classes.fullName}>
                                <span className={classes.familyName}>{patientObject.familyName}</span>
                                {patientObject.firstName}
                            </div>
                        </div>
                        <div className={classes.headerText}>
                            {t("Born")} <strong>{patientDOB()}</strong> - ({patientYears()} {t("years")})
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            {t("Gender")}: <strong>{patientObject.gender}</strong>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            {t("MRN")}: <strong>{patientObject.hospitalNumber}</strong>
                        </div>
                        {patientObject &&
                            <PatientInfo
                                eyonix
                                patient={patientObject}
                                header={true} />
                        }
                    </div>
                );
            }
            if (isHoldingPenViewer){
                return (
                    <div className={classes.headerObject}>
                        <div className={classes.headerName}>
                            {backButtonVisible() && <IconButton size="small" onClick={handleBackButton}>
                                <BackIcon />
                            </IconButton> }
                        </div>
                    </div>
                )
            }
            if (isResearchViewer){
                return (
                    <div className={classes.headerObject}>
                        {isResearchViewer && <div className={classes.headerName}>
                            {backButtonVisible() && <IconButton size="small" onClick={handleBackButton}>
                                <BackIcon />
                            </IconButton> }
                        </div>}
                        <div className={classes.headerText}>
                            {/*<ScienceIcon className={classes.smallerIcon}/>*/}
                            <strong>RESEARCH MODULE</strong>
                        </div>
                    </div>
                );
            }
            if (patientObject && isResearch && !isResearchViewer && process.env.BUILD_MODULE === "main") {
                return (
                    <div className={classes.headerObject}>
                        <div className={classes.headerText}>
                            {/*<ScienceIcon className={classes.smallerIcon}/>*/}
                            <strong>RESEARCH MODULE</strong>
                        </div>
                        {patientObject &&
                            <PatientInfo
                                eyonix
                                research
                                researchReload={researchReload}
                                patient={patientObject}
                                header={true} />
                        }
                      </div>
                );
            }
        }
    };

    const handleBackButton = () => {
        if(isHoldingPenViewer && (process.env.BUILD_MODULE != "lwh" && process.env.BUILD_MODULE != "dch" &&
            process.env.BUILD_MODULE != "stg" && process.env.BUILD_MODULE != "mse")){
            dispatch(loadDocumentsForPatientById(t, config.modules.holdingPen.name));
            history.push("/holding");
        } else if(isResearchViewer && (process.env.BUILD_MODULE != "lwh" && process.env.BUILD_MODULE != "dch" &&
            process.env.BUILD_MODULE != "stg" && process.env.BUILD_MODULE != "mse")){
            dispatch(loadDocumentsForPatientById(t, config.modules.research.name));
            if(isResearch) {
                history.push("/research?section=researchList");
            } else {
                history.push("/researchholding");
            }
        } else {
            if (history.location.pathname.includes("view")) {
                dispatch(setGlobalVariable({
                    name: "backFromView",
                    value: true,
                }));
            } else {
                    history.push("/");
                    //history.goBack();
            }
        }
    };

    const handleReloadHoldingPen = () => {
        dispatch(loadDocumentsForPatientById(t, config.modules.holdingPen.name, true));
    };

    const handleReloadResearchHoldingPen = () => {
        dispatch(loadDocumentsForPatientById(t, config.modules.research.name, true));
        // dispatch(loadDocumentsForPatientById(t, config.modules.research.name, true, JSON.stringify(config.modules.research.holdingDocumentsFilter)));
    };

    const handleGoToResearch = () => {
        history.push("/research?section=researchList");
    }

    const handleGoToEyonix = () => {
        history.push('/');
    }

    const filterPreferences = useSelector(patientPreferences);
    const selectedDocumentsFromPatient = useSelector(getSelectedDocuments);

    const getHeaderForHoldingPen = () => {
        if(!canAccessHoldingPen) {
            return (<React.Fragment></React.Fragment>);
        } else {

            const userMenuButton = (<div className={classes.linksIcon}>
                <IconButton
                    onClick={openHoldingPenMenu}
                    className={[classes.menuIcon].join(" ")}
                    size="large">
                    <PersonIcon/>
                </IconButton>
            </div>);

            if (documentsObject && documentsObject.__data) {
                const pageCount = () => {
                    return Math.ceil(holdingPreferenceObject.documentsCount / config.modules.holdingPen.pageSize);
                };

                return (
                    <React.Fragment>
                        {(process.env.BUILD_MODULE === "lwh" || process.env.BUILD_MODULE === "dch" || process.env.BUILD_MODULE === "mse") && userMenuButton}
                        <div className={classes.headerText}>
                            {process.env.BUILD_MODULE === "main" &&
                                <div className={classes.buttonsContainers}>
                                    <AgyleButton variant="outlined" color="primary"
                                                 style={{margin: "0 15px"}}
                                                 onClick={handleGoToEyonix}
                                    >
                                        {t("Main Application")}
                                    </AgyleButton>

                                    <Tooltip title={t("Reload")}>
                                        <IconButton
                                            onClick={handleReloadHoldingPen}
                                            aria-label="Reload"
                                            size="large">
                                            <CachedIcon/>
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title={t("Create patient")}>
                                        <IconButton
                                            edge="end"
                                            aria-label="Create patient"
                                            disabled={!canCreatePatient}
                                            onClick={(e) => openNewPatientModal()}
                                        >
                                            <PersonAddIcon/>
                                        </IconButton>
                                    </Tooltip>
                                </div>
                            }
                            {!holdingPreferenceObject.fullViewMode &&

                            <div style={{display: "inline-block"}}>
                                <div style={{display: "inline-block"}}>
                                    {t("Page ... ")}&nbsp;
                                </div>
                                <div style={{display: "inline-block"}}>
                                    <Pagination page={holdingPreferenceObject.pageSelected}
                                                disabled={(filterPreferences.bulkActionMode === "hide"? Object.keys(selectedDocumentsFromPatient).length !== 0: false)}
                                                onChange={(_e, page) => {
                                                    dispatch(setHoldingPreference({
                                                        pageSelected: page,
                                                    }));
                                                }}
                                                count={pageCount()} shape="rounded"/>
                                </div>
                                <div style={{display: "inline-block"}}>
                                    {t("... of")}&nbsp;<strong>{holdingPreferenceObject.documentsCount}</strong>
                                    &nbsp;{t("documents")}&nbsp;
                                    <span style={{marginLeft: 50, fontSize: "80%"}}>
                                        {t("page size")}: {config.modules.holdingPen.pageSize}
                                    </span>
                                </div>


                            </div>

                            }
                            {holdingPreferenceObject.fullViewMode &&
                                <div style={{display: "inline-flex", alignItems: "center", height: 48}} >
                                    <IconButton  onClick={()=>{
                                        dispatch(setHoldingPreference({
                                            selectedDocumentIndex: holdingPreferenceObject.selectedDocumentIndex - 1,
                                        }));
                                    }} disabled={holdingPreferenceObject.selectedDocumentIndex === 1}>
                                        <BackIcon />
                                    </IconButton>

                                    <div style={{display: "inline-flex", alignItems: "center"}} >
                                        <div className={classes.documentCountBox}>
                                            <strong style={{marginRight: 5}}>{holdingPreferenceObject.selectedDocumentIndex} </strong>  / {holdingPreferenceObject.documentsCount}
                                        </div>

                                    </div>

                                    <IconButton  onClick={()=>{
                                        dispatch(setHoldingPreference({
                                            selectedDocumentIndex: holdingPreferenceObject.selectedDocumentIndex + 1,
                                        }));
                                    }} disabled={holdingPreferenceObject.selectedDocumentIndex === holdingPreferenceObject.documentsCount}>
                                        <BackIcon style={{rotate: "180deg"}}/>
                                    </IconButton>

                                </div>
                            }
                            {/*
                    // TODO: PAGING display !!!!
                    <span style={{marginRight: 10, fontWeight: 300, opacity: .8}}>
                        {t("Document count currently in holding")}:</span>
                    <span style={{fontSize: "110%"}}>
                        <strong>{documentsObject.__data.length}</strong>
                    </span>
                    */}
                        </div>
                    </React.Fragment>
                );
            } else {
                return (
                    <React.Fragment>
                        {(process.env.BUILD_MODULE === "lwh" || process.env.BUILD_MODULE === "dch" || process.env.BUILD_MODULE === "mse") && userMenuButton}
                        <div className={classes.headerText}>
                            {t("No documents loaded")}
                        </div>
                    </React.Fragment>
                );
            }
        }
    };

    const getHeaderForResearchHoldingPen = () => {
        if(!canAccessResearchHoldingPen) {
            return (<React.Fragment></React.Fragment>);
        } else {
            if (documentsObject && documentsObject.__data) {
                const pageCount = () => {
                    return Math.ceil(holdingPreferenceObject.documentsCount / config.modules.research.pageSize);
                };

                return (
                    <React.Fragment>
                        <div className={classes.headerText}>
                            <div style={{textAlign: "left", width: "auto"}} className={classes.headerName}>
                                {/*<ScienceIcon className={classes.smallerIcon}/>*/}
                                <strong>RESEARCH MODULE</strong>
                            </div>
                            {process.env.BUILD_MODULE === "main" &&
                                <div className={classes.buttonsContainers}>
                                    <AgyleButton variant="outlined" color="primary"
                                                 style={{margin: "0 15px"}}
                                                 onClick={handleGoToResearch}
                                    >
                                        {t("Research List")}
                                    </AgyleButton>
                                    <AgyleButton variant="outlined" color="primary"
                                                 style={{margin: "0 15px"}}
                                                 onClick={handleGoToEyonix}
                                    >
                                        {t("Main Application")}
                                    </AgyleButton>
                                    <Tooltip title={t("Reload")}>
                                        <IconButton
                                            onClick={handleReloadResearchHoldingPen}
                                            aria-label="Reload"
                                            size="large">
                                            <CachedIcon/>
                                        </IconButton>
                                    </Tooltip>
                                </div>
                            }
                            <div style={{display: "inline-block"}}>
                                <div style={{display: "inline-block"}}>
                                    {t("Page ... ")}&nbsp;
                                </div>
                                <div style={{display: "inline-block"}}>
                                    <Pagination page={holdingPreferenceObject.pageSelected}
                                                onChange={(_e, page) => {
                                                    dispatch(setHoldingPreference({
                                                        pageSelected: page,
                                                    }));
                                                }}
                                                count={pageCount()} shape="rounded"/>
                                </div>
                                <div style={{display: "inline-block"}}>
                                    {t("... of")}&nbsp;<strong>{holdingPreferenceObject.documentsCount}</strong>
                                    &nbsp;{t("documents")}&nbsp;
                                    <span style={{marginLeft: 50, fontSize: "80%"}}>
                                        {t("page size")}: {config.modules.research.pageSize}
                                    </span>
                                </div>


                            </div>

                        </div>
                    </React.Fragment>
                );
            } else {
                return (
                    <React.Fragment>
                        <div className={classes.headerText}>
                            {t("No documents loaded")}
                        </div>
                    </React.Fragment>
                );
            }
        }
    };

    const [menuState, setMenuState] = React.useState(false);
    const openMenu = () => {
        setMenuState(true);
    };
    const closeMenu = () => {
        setMenuState(false);
    };
    const [linksState, setLinksState] = React.useState(false);
    const openLinks = () => {
        setLinksState(true);
    };
    const closeLinks = () => {
        setLinksState(false);
    };
    const [holdingPenMenuState, setHoldingPenMenuState] = React.useState(false);
    const openHoldingPenMenu = () => {
        setHoldingPenMenuState(true);
    };
    const closeHoldingPenMenu = () => {
        setHoldingPenMenuState(false);
    };

    return (
        <div className={classes.headerPanel}>
            <SwipeableDrawer
                anchor={'left'}
                open={menuState}
                onClose={closeMenu}
                onOpen={openMenu}
            >
                <UserMenu open={menuState} />
            </SwipeableDrawer>
            {process.env.BUILD_MODULE !== "main" &&
                <SwipeableDrawer
                    anchor={'right'}
                    open={linksState}
                    onClose={closeLinks}
                    onOpen={openLinks}
                >
                    <Links close={closeLinks}/>
                </SwipeableDrawer>
            }
            {holdingPenMenuState && <SwipeableDrawer
                anchor={'right'}
                open={holdingPenMenuState}
                onClose={closeHoldingPenMenu}
                onOpen={openHoldingPenMenu}
            >
                <HoldingPenMenu close={closeHoldingPenMenu}></HoldingPenMenu>
            </SwipeableDrawer>
            }

            {canCreatePatient &&
            <AgyleDialog
                title={"Add Patient"}
                open={isNewPatientModalOpen}
                onClose={() => {
                    closeNewPatientModal()
                }}
                width={"lg"}
                fullWidth
                fullScreen
                disableActions
                closeButtonOnHeader
            >

                <AdminPatientEyonix closeModal={() => {
                    closeNewPatientModal()
                }}/>
            </AgyleDialog>
            }

            {!isHoldingPen && !isResearchHolding && getHeaderPatientElement()}
            {isHoldingPen && getHeaderForHoldingPen()}
            {isResearchHolding && getHeaderForResearchHoldingPen()}
            {process.env.BUILD_MODULE === "main" &&
                <IconButton onClick={openMenu} classes={{ root: classes.menuIcon }} size="large">
                    <SvgIcon className="big_svg_icon" color="primary">
                        <path d="M21.493,2l-9.558,0.001C6.444,2.04,2,6.505,2,12.008c0,0.013,0,7.37,0,9.448C2.007,21.758,2.23,22,2.504,22h9.625
					c5.393-0.065,9.752-4.392,9.871-9.77V2.557C22,2.248,21.772,2,21.493,2z M18.66,18.298c-0.004,0.201-0.151,0.363-0.335,0.363
					h-6.411c-3.592-0.042-6.496-2.926-6.574-6.509V5.708c0-0.205,0.151-0.371,0.336-0.371h6.366c3.66,0.027,6.618,3.003,6.618,6.667
					C18.66,12.012,18.66,16.915,18.66,18.298z"/>
                        <path d="M12.002,7.163c-2.673,0-4.838,2.168-4.838,4.836c0,2.672,2.165,4.838,4.838,4.838c2.669,0,4.836-2.166,4.834-4.838
					C16.836,9.331,14.671,7.163,12.002,7.163z"/>
                    </SvgIcon>
                </IconButton>

            }
            {/* FIXME: This needs to be refactored */}
            {process.env.BUILD_MODULE === "agyle" &&
                <div className={classes.linksIcon}>
                    <IconButton
                        onClick={() => {
                            history.push('/ward/ED');
                        }}
                        className={[classes.menuIcon].join(" ")}
                        size="large">
                        <MedicationIcon />
                    </IconButton>
                    <IconButton
                        onClick={openLinks}
                        className={[classes.menuIcon].join(" ")}
                        size="large">
                        <LinkIcon />
                    </IconButton>
                </div>
            }
        </div>
    );
}

export default Header;